import { createElement } from 'react'
import { Modal } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { ComponentController } from './component_controller'
import { dispatcher } from '../pub_controller'
import { DispatchEvent } from '../../types'
import { Confirmable } from '../../models'

type ModalProps = {
  body: string
  onCancel: any
  onOk: any
  open: boolean
  title: string
}

const ModalElement = ({ title, open, onOk, onCancel, body }: ModalProps) => {
  return createElement(
    Modal,
    {
      key: title,
      title: title,
      open: open,
      onOk: onOk,
      onCancel: onCancel,
      footer: ModalFooter({ onOk, onCancel }),
      className: 'modal',
    },
    ModalBody({ body, title }),
  )
}

const ModalFooter = ({ onOk, onCancel }: any) => {
  return createElement('div', null, [
    createElement(
      'button',
      { key: 'back', className: 'modal-button--default', onClick: onCancel },
      'CANCEL',
    ),
    createElement(
      'button',
      { key: 'submit', className: 'modal-button--confirm', onClick: onOk },
      'OK',
    ),
  ])
}

const ModalBody = ({ body, title }: any) => {
  return createElement('div', null, [
    createElement(CloseCircleOutlined, {
      key: `${title}-icon`,
      className: 'modal-body-icon',
    }),
    createElement(
      'span',
      { key: `${title}-body`, className: 'modal-body-text' },
      body,
    ),
  ])
}

export class ConfirmationModalController extends ComponentController {
  declare confirmable: Confirmable

  newConfirmation(event: DispatchEvent<{ detail: Confirmable }>) {
    this.confirmable = event.detail
    this.updateProps({
      open: true,
      title: this.confirmable.confirmationTitle,
      body: this.confirmable.confirmationMessage,
    })
  }

  openModal() {
    this.updateProps({ open: true })
  }

  closeModal() {
    this.updateProps({ open: false })
  }

  modalConfirmation() {
    dispatcher(
      this,
      this.confirmable.pubAs,
      this.confirmable.pubChannel,
      this.confirmable.detail,
    )
  }

  get component() {
    return ModalElement
  }

  get initialProps() {
    const props = this.propsFromData
    return {
      ...props,
      onOk: this.modalConfirmation.bind(this),
      onCancel: this.closeModal.bind(this),
    }
  }
}
